module.exports = __webpack_public_path__ + "img/abimg8.bb570da1.png";